module.exports = __webpack_public_path__ + "static/media/mx.216d2ed6.svg";